(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ps-nav"] && !Shopify.designMode) return;
  try {
    (() => {
 const fill = () => {
  const q = new URLSearchParams(location.search);
  const clean = (key, limit) => (q.get(key) || '').replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').slice(0, limit);
  const form = document.querySelector('.ps-request-form');
  if (!form) return;
  if(q.get('from') === 'find-your-piece'){
   [['brief','[data-ps3-sourcing-notes]',1800],['budget','[data-ps7-budget]',150],['material','[data-ps7-material]',200],['variety','[data-ps7-variety]',150],['use','[data-ps7-use]',250]].forEach(([key,selector,limit]) => {const field=form.querySelector(selector),value=clean(key,limit);if(field && !field.value && value) field.value=value;});
  }
  const category=form.querySelector('[data-ps7-category]');let value=clean('category',60);
  if(['handheld-objects','desk-display'].includes(value))value='collector-objects';
  if(category && !category.value && Array.from(category.options).some(o=>o.value===value)) category.value=value;
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fill,{once:true});else fill();
 document.addEventListener('shopify:section:load',fill);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ps9213-nav-backup"] && !Shopify.designMode) return;
  try {
    /* Only prefill requests explicitly handed off by Find Your Piece. Never overwrite entered text. */
(() => {
 const fill = () => {
  const q = new URLSearchParams(location.search);
  if (q.get('from') !== 'find-your-piece') return;
  const clean = (key, limit) => (q.get(key) || '').replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').slice(0, limit);
  const form = document.querySelector('.ps-request-form');
  if (!form) return;
  [['brief','[data-ps3-sourcing-notes]',1800],['budget','[data-ps7-budget]',150],['material','[data-ps7-material]',200],['variety','[data-ps7-variety]',150],['use','[data-ps7-use]',250]].forEach(([key,selector,limit]) => {const field=form.querySelector(selector),value=clean(key,limit);if(field && !field.value && value) field.value=value;});
  const category=form.querySelector('[data-ps7-category]'), value=clean('category',60);
  if(category && !category.value && Array.from(category.options).some(o=>o.value===value)) category.value=value;
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fill,{once:true});else fill();
 document.addEventListener('shopify:section:load',fill);
})();
  } catch(e) { console.error(e); }
})();

})();
